// 모바일 헤더 따로 들어가는 경우 :  meta: { mobileHd: true },
// 모바일 헤더에 찜하기 버튼 있는 경우 : meta: { likeBtn: true },
// 인하대 페이지일 경우 : meta: { site: 'inha' }
const mainRoutes = [
  {
    path: "main",
    name: "studentMain",
    meta: {
      title: "메인",
      mobileTitle: "메인",
      gnbBtn: true,
      site: "inha",
    },
    component: () => import("@/views/student/main/StudentMainIndex-inha.vue"),
  },
  {
    path: "recentFeed",
    name: "studentRecentFeed",
    meta: {
      title: "최신 알림",
      mobileTitle: "최신 알림",
      mobileHd: true,
      homeBtn: true,
      gnbBtn: true,
    },
    component: () => import("@/views/common/main/RecentFeed.vue"),
  },
  {
    path: "recentFeed/detail",
    name: "studentRecentFeedDetail",
    meta: {
      title: "최신 알림 상세",
      mobileTitle: "알림 목록",
      mobileHd: true,
    },
    component: () => import("@/views/common/main/RecentFeedDetail.vue"),
  },
];
export default mainRoutes;
